module.exports = __webpack_public_path__ + "static/media/restore.332c7a93.svg";